let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ilw9Q")).then(() => parcelRequire('fx9se'));